export const TABLE_HEADERS = [
  "name",
  "serial",
  "claimed_by",
  "date_claimed",
  "properties.state.state",
  "alarm",
];
